import config from './config'

/**
 * Модуль ожидания запуска
 */
export function waitModuleReady (isReady, callback, timer = 1000) {
  const intervalCall = setInterval(() => {
    if (config.DEVMODE) {
      console.log('interval: ', isReady())
    }
    if (isReady()) {
      clearInterval(intervalCall)
      callback()
    }
  }, timer)
}
